{
  "title": "Controleren en opslaan",
  "correction_warnings": "Je kan de resultaten van dit stembureau nog niet opslaan. Los onderstaande waarschuwingen op om verder te gaan.",
  "counts_add_up": {
    "warnings": "De aantallen die je hebt ingevoerd in de verschillende stappen spreken elkaar niet tegen. Er zijn waarschuwingen die moeten worden gecontroleerd.",
    "no_warnings": "De aantallen die je hebt ingevoerd in de verschillende stappen spreken elkaar niet tegen. Er zijn geen blokkerende fouten of waarschuwingen."
  },
  "counts_do_not_add_up": "De aantallen die je hebt ingevoerd in de verschillende stappen spreken elkaar tegen. Je kan de resultaten daarom niet opslaan.",
  "no_warnings": "Er zijn geen blokkerende fouten of waarschuwingen",
  "warnings": "Er zijn waarschuwingen die moeten worden gecontroleerd",
  "check_warnings": "Controleer de openstaande waarschuwingen",
  "fix_the_errors": "Los de blokkerende fouten op. Lukt dat niet? Overleg dan met de coördinator.",
  "counts_add_up_title": "Alle optellingen kloppen",
  "can_not_save": "Je kan de resultaten van dit stembureau nog niet opslaan",
  "can_save": "Je kan de resultaten van dit stembureau opslaan",
  "accepted_errors": "Het papieren proces-verbaal bevat een aantal fouten. Overleg met de coördinator wat te doen.",
  "notable_form_sections": {
    "empty": "Op <link>{link_title}</link> zijn geen stemmen ingevoerd",
    "accepted-warnings": "<link>{link_title}</link> heeft geaccepteerde waarschuwingen",
    "unaccepted-warnings": "Controleer waarschuwingen bij <link>{link_title}</link>",
    "errors": "<link>{link_title}</link> heeft blokkerende fouten"
  }
}
